/* eslint-disable complexity, max-statements, key-spacing, wrap-iife */
(function($) {
  'use strict';

  var desktopMediaQuery = '(min-width: 60em)';
  var stickyNavHeight = $('.inpage-nav').height() || 0;

  $('.js-tabs-cct').each(function(containerIdx) {
    var $tabsCct = $(this);

    $tabsCct.prepend(
      '<div class="tabs-cct__controls js-tabs-cct-controls" role="tablist"></div>'
    );
    var $tabsCctControls = $tabsCct.find('.js-tabs-cct-controls');

    var mqMatchMedia = window.matchMedia(desktopMediaQuery);

    function handleMQChange(mql) {
      $tabsCct
        .find('.js-tabs-cct-title')
        .removeClass('active')
        .attr('aria-expanded', 'false');
      $tabsCct
        .find('.js-tabs-cct-text')
        .removeClass('active')
        .removeAttr('style');
      if (mql.matches) {
        $tabsCct
          .find('.js-tabs-cct-title')
          .first()
          .addClass('active')
          .attr('aria-expanded', 'true');
        $tabsCct
          .find('.js-tabs-cct-text')
          .first()
          .slideDown(300, function() {
            $(this)
              .addClass('active')
              .removeAttr('style');
          });
      } else {
        $tabsCct.find('.js-tabs-cct-title').removeClass('active');
      }
    }

    mqMatchMedia.addEventListener('change', handleMQChange);
    handleMQChange(mqMatchMedia);

    $tabsCct.find('.js-tabs-cct-title').each(function(tabIdx) {
      var toggleId = 'tab-' + (containerIdx + 1) + '-toggle-' + (tabIdx + 1);
      var textId = 'tab-' + (containerIdx + 1) + '-text-' + (tabIdx + 1);
      var tabId = 'tab-' + (containerIdx + 1) + '-tab-' + (tabIdx + 1);
      var $tabsCctToggle = $(this);
      var $tabsCctText = $tabsCctToggle.siblings('.js-tabs-cct-text');
      var isActive = $tabsCctToggle.hasClass('active');
      var isFirst = tabIdx === 0;
      var isLast = tabIdx === $tabsCct.find('.js-tabs-cct-title').length - 1;

      $tabsCctToggle.attr('aria-controls', textId);
      $tabsCctText.attr({
        id: textId,
        role: 'tabpanel',
        'aria-labelledby': toggleId,
        tabindex: '-1',
      });
      $tabsCctToggle.clone(true).appendTo($tabsCctControls);
      $tabsCctToggle.attr({
        id: toggleId,
        'aria-expanded': isActive ? 'true' : 'false',
      });

      var $tabsCctTab = $tabsCctControls.find(
        '.js-tabs-cct-title[aria-controls="' + textId + '"]'
      );
      $tabsCctTab.attr({
        id: tabId,
        role: 'tab',
        'aria-selected': isActive ? 'true' : null,
        tabindex: isActive ? null : '-1',
      });

      $tabsCctToggle.on('click', function(e) {
        e.preventDefault();
        var isToggleActive = $tabsCctToggle.hasClass('active');
        $tabsCct
          .find('.js-tabs-cct-title')
          .removeClass('active')
          .attr('aria-expanded', 'false');
        $tabsCct.find('.js-tabs-cct-text').slideUp(300, function() {
          $(this)
            .removeClass('active')
            .removeAttr('style');
        });
        if (!isToggleActive) {
          $tabsCctToggle.addClass('active').attr('aria-expanded', 'true');
          $tabsCctTab.addClass('active').attr('aria-expanded', 'true');
          $tabsCctText.slideDown(300, function() {
            $tabsCctText.addClass('active').removeAttr('style');
            $([document.documentElement, document.body]).animate(
              {
                scrollTop: $tabsCctToggle.offset().top - stickyNavHeight - 10,
              },
              200
            );
          });
        }
      });

      $tabsCctTab
        .on('click', function(e) {
          e.preventDefault();
          if (!$tabsCctToggle.hasClass('active')) {
            $tabsCct
              .find('.js-tabs-cct-title')
              .removeClass('active')
              .filter('[aria-expanded]')
              .attr('aria-expanded', 'false');
            $tabsCctControls
              .find('.js-tabs-cct-title')
              .removeAttr('aria-selected')
              .attr('tabindex', '-1');
            $tabsCct.find('.js-tabs-cct-text').removeClass('active');
            $tabsCctToggle.addClass('active').attr('aria-expanded', 'true');
            $tabsCctTab
              .addClass('active')
              .attr('aria-selected', 'true')
              .removeAttr('tabindex');
            $tabsCctText.addClass('active');
          }
        })
        .on('keydown', function(e) {
          if (e.key === 'ArrowRight' && !isLast) {
            $tabsCctTab
              .next()
              .trigger('click')
              .trigger('focus');
          }
          if (e.key === 'ArrowLeft' && !isFirst) {
            $tabsCctTab
              .prev()
              .trigger('click')
              .trigger('focus');
          }
          if (e.key === 'ArrowDown') {
            $tabsCctText.trigger('focus');
          }
        });
    });
  });
})(jQuery);
